import { DatePipe, DOCUMENT } from '@angular/common';
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  AfterViewInit,
  Input
} from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/shared/_service/config.service';
import { AuthService } from 'src/app/core/service/auth.service';
import { WINDOW } from 'src/app/core/service/window.service';
import { UnsubscribeOnDestroyAdapter } from 'src/app/shared/UnsubscribeOnDestroyAdapter';
import { DataManagmentService } from 'src/app/shared/_service/data-managment.service';
import { take, takeUntil, takeWhile } from 'rxjs';
import { ApiService } from 'src/app/shared/_service/api.service';
import { ENDPOINTS, UrlService } from 'src/app/shared/_service/url.service';
import { CustomJsona } from 'src/app/shared/Jsona extended/CustomJsona';
const document: any = window.document;
const dataFormatter = new CustomJsona()

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass']
})
export class HeaderComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit, AfterViewInit {
  public config: any = {};
  isNavbarCollapsed = true;
  isNavbarShow = true;
  flagvalue;
  countryName;
  langStoreValue: string;
  defaultFlag: string;
  isOpenSidebar!: boolean;
  @Input() hideCollapseIcon = false;
  currentUser;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(WINDOW) private window: Window,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private configService: ConfigService,
    private authService: AuthService,
    private router: Router,
    private GLOBAL: DataManagmentService,
    private datePipe: DatePipe,
    private apiSer: ApiService,
    private url: UrlService
  ) {
    super();
  }

  notifications: any[] = [];
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const offset =
      this.window.pageYOffset ||
      this.document.documentElement.scrollTop ||
      this.document.body.scrollTop ||
      0;
    // if (offset > 50) {
    //   this.isNavbarShow = true;
    // } else {
    //   this.isNavbarShow = false;
    // }
  }

  ngOnInit() {
    this.config = this.configService.configData;

    this.GLOBAL.currentUserData.pipe(takeWhile(u => !u.alertSottoscorta, true)).subscribe(user => {
      if (user.alertSottoscorta) {
        console.log('USER:', user)
        this.notifications.push({
          message: 'Analisi articoli sotto scorta terminata. Nuovi elementi trovati.',
          time: this.datePipe.transform(new Date()),
          icon: 'mail',
          color: 'nfc-green',
          status: 'msg-unread'
        })
      }

      this.currentUser = user;
    })
  }
  ngAfterViewInit() {
    this.renderer.addClass(this.document.body, this.config.layout.variant);
    this.renderer.addClass(
      this.document.body,
      'menu_' + this.config.layout.sidebar.backgroundColor
    );
    this.renderer.addClass(
      this.document.body,
      'logo-' + this.config.layout.logo_bg_color
    );
    if (this.config.layout.sidebar.collapsed === true) {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }
  callFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }

  mobileMenuSidebarOpen(event: any, className: string) {
    const hasClass = event.target.classList.contains(className);
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }
  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains('side-closed');
    if (hasClass) {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    } else {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }
  logout() {
    console.log(this.authService.logout())
    /*if (this.authService.logout()){
      //window.localStorage.removeItem('app_token');
      this.router.navigate(['/']);
    };*/
  }

  // NOTIFICATIONS
  getUnreadNotifications() {
    return this.notifications.filter(n => n.status === 'msg-unread');
  }

  markAsRead(index?: number) {
    if (index) { // If index is specified, mark the one as read
      this.notifications[index].status = 'msg-read';
    } else { // Otherwise, mark all as read
      this.notifications.forEach(n => n.status = 'msg-read');
    }

    this.disableUserAlert();
  }

  deleteNotification(index: number) {
    this.notifications.splice(index, 1);

    this.disableUserAlert();
  }

  disableUserAlert() {
    const body = dataFormatter.serialize({
      stuff: {
        type: 'utenti',
        alert_sottoscorta: false,
        id: this.currentUser.uid
      }
    });

    this.apiSer
      .patchRequest(this.url.getBackendUrl() + ENDPOINTS.users + '/' + this.currentUser.uid, body)
      .subscribe();
  }
}
